import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-secondary-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Контактная информация */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Контактна інформація</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <Phone size={18} className="mr-2 text-primary-400" />
                <span>+38(0372)584705</span>
              </div>
              <div className="flex items-center">
                <Mail size={18} className="mr-2 text-primary-400" />
                <a href="mailto:profcom@chnu.edu.ua" className="hover:text-primary-400 transition">
                  profcom@chnu.edu.ua
                </a>
              </div>
              <div className="flex items-start">
                <MapPin size={18} className="mr-2 mt-1 text-primary-400" />
                <span>м. Чернівці, вул. Коцюбинського 2, каб. 125, 126</span>
              </div>
            </div>
          </div>

          {/* Быстрые ссылки */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Швидкі посилання</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-primary-400 transition">Головна</Link>
              </li>
              <li>
                <Link to="/discounts" className="hover:text-primary-400 transition">Каталог знижок</Link>
              </li>
                <li>
                <a 
                  href="https://profcom.chnu.edu.ua/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary-400 transition flex items-center"
                >
                  Сайт профкому <ExternalLink size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <a 
                  href="https://invite.viber.com/?g2=AQACXEVSwtXL21RgJFEUsGdH%2BRWlDydZHfAoI4tocl6jdTyGHk51%2B%2B5QgxDimnUs" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary-400 transition flex items-center"
                >
                  Viber-канал <ExternalLink size={14} className="ml-1" />
                </a>
              </li>
            </ul>
          </div>

          {/* про проєкт */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Про проєкт</h3>
            <p className="text-gray-300 mb-4">
              Програма лояльності "ПрофБонус" - це система знижок та бонусів для викладачів та співробітників Чернівецького національного університету імені Юрія Федьковича від Профспілкової організації університету.
            </p>
            <div className="mt-4">
              <Link to="/login" className="bg-primary-600 text-white px-4 py-2 rounded-md hover:bg-primary-700 transition">
                Головна сторінка
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-700 text-center text-gray-400">
          <p>© {new Date().getFullYear()} ПрофБонус. Всі права захищені.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
